import axios from 'axios';

// Base URL
const API = axios.create({baseURL: "https://expert-ai-backend.herokuapp.com/"});

// Adding headers to an API request.
API.interceptors.request.use((req) =>{
    if(localStorage.getItem('profile')) {
        req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
    }
    return req;
});

// User 
export const signIn = (formData) => API.post('/user/signin', formData);
export const signUp = (formData) => API.post('/user/signup', formData);

// HeartPost
export const fetchHeartPosts = (pageNumber) => API.get(`/heartposts?page=${pageNumber}`);
export const createHeartPost = (heartpost) => API.post('/heartposts/', heartpost);
export const updateHeartPost = (id, updatedHeartPost) => API.patch(`/heartposts/${id}`, updatedHeartPost);
export const deleteHeartPost = (id) => API.delete(`/heartposts/${id}`);

// DiabetesPost
export const fetchDiabetesPosts = (pageNumber) => API.get(`/diabetesposts?page=${pageNumber}`);
export const createDiabetesPost = (diabetespost) => API.post('/diabetesposts/', diabetespost);
export const updateDiabetesPost = (id, updatedDiabetesPost) => API.patch(`/diabetesposts/${id}`, updatedDiabetesPost);
export const deleteDiabetesPost = (id) => API.delete(`/diabetesposts/${id}`);

// StrokePost
export const fetchStrokePosts = (pageNumber) => API.get(`/strokeposts?page=${pageNumber}`);
export const createStrokePost = (strokepost) => API.post('/strokeposts/', strokepost);
export const updateStrokePost = (id, updatedStrokePost) => API.patch(`/strokeposts/${id}`, updatedStrokePost);
export const deleteStrokePost = (id) => API.delete(`/strokeposts/${id}`);

// CreditPost
export const fetchCreditPosts = (pageNumber) => API.get(`/creditposts?page=${pageNumber}`);
export const createCreditPost = (creditpost) => API.post('/creditposts/', creditpost);
export const updateCreditPost = (id, updatedCreditPost) => API.patch(`/creditposts/${id}`, updatedCreditPost);
export const deleteCreditPost = (id) => API.delete(`/creditposts/${id}`);

// LoanPost
export const fetchLoanPosts = (pageNumber) => API.get(`/loanposts?page=${pageNumber}`);
export const createLoanPost = (loanpost) => API.post('/loanposts/', loanpost);
export const updateLoanPost = (id, updatedLoanPost) => API.patch(`/loanposts/${id}`, updatedLoanPost);
export const deleteLoanPost = (id) => API.delete(`/loanposts/${id}`);

// InsurancePost
export const fetchInsurancePosts = (pageNumber) => API.get(`/insuranceposts?page=${pageNumber}`);
export const createInsurancePost = (insurancepost) => API.post('/insuranceposts/', insurancepost);
export const updateInsurancePost = (id, updatedInsurancePost) => API.patch(`/insuranceposts/${id}`, updatedInsurancePost);
export const deleteInsurancePost = (id) => API.delete(`/insuranceposts/${id}`);

